<template>
    <main-site>
        <template #main_content>
            <inertia-head>
                <!-- <title v-if="!seo.page_title" name="title">{{master.user?.fullName}}</title> -->
                <!-- <title v-else name="title">{{ seo.page_title }}</title> -->
                <title name="title">{{ master.user?.fullName }} | Certified Personal Trainer</title>
                <meta v-show="seo.page_description" name="description" :content="`${textShorter(seo.page_description, null)}`"/>
                <meta v-show="seo.key_words" name="keywords" :content="`${seo.key_words}`"/>
                <meta property="og:title" :content="master.user?.fullName"/>
                <meta v-show="seo.key_words" property="og:description" :content="`${textShorter(seo.page_description, null)}`"/>
                <meta name="twitter:title" :content="`${master.user?.fullName}`">
                <link v-if="!seo.canonical_tag" rel="canonical" :href="canonicalLink"/>
                <link v-else rel="canonical" :href="`${seo.canonical_tag}`" />
                <meta v-if="seo.noindex_tag" name="robots" :content="`${seo.noindex_tag}`" />
            </inertia-head>

            <loading :show="isLoading"/>

            <div class="container mx-auto pt-[50px] lg:pt-1">
                <!-- Sorry for set CourseDialog :( -->
                <div v-if="!CourseDialog && $page.props.error" class="mb-4 font-medium text-sm bg-red-100 p-4 text-red-600 rounded-md">
                    <span>{{$page.props.error}}</span>
                </div>

                <div v-show="$page.props.success" class="mb-4 font-medium text-sm bg-green-200 p-4 text-dark rounded-md">
                    <span>{{$page.props.success}}</span>
                </div>

                <section class="grid grid-cols-12 gap-2 mx-2">
                    <div class="rounded-2xl shadow-lg bg-white col-span-12 sm:col-span-8 my-1">
                        <div class="md:flex sm:divide-x-2 divide-gray-500">
                            <div class="sm:p-3 p-1 sm:w-4/6">
                                <figure class="sm:p-4 p-2 sm:flex grid">
                                    <div>
                                        <div class="grid justify-center">
                                            <div class="master-lists-avatar rounded-full mx-auto border ring ring-offset-2 ring-gray-300 shadow-md">
                                                <img :src="`${master.user?.profile_photo_url}?w=160&h=160`"
                                                    :alt="`Trainer ${master.user?.fullName}`"
                                                    width="160"
                                                    height="160"
                                                    class="img-cover rounded-full">
                                            </div>
                                        </div>
                                        <div class="flex justify-center items-center mt-3">
                                            <span class="material-icons text-green-600 text-3xl">location_on</span>
                                            <a class="font-bold"> {{ master.user?.city?.title }} </a>
                                        </div>
                                    </div>
                                    <div class="grid ml-4">
                                        <div class="sm:text-left text-center">
                                            <h2 class="text-2xl font-bold my-2 text-gray-700">
                                                {{ master.user?.fullName }}
                                            </h2>
                                            <span class="master-level my-2"> 
                                                {{ master.rate_text }}
                                            </span>
                                        </div>
                                        <!-- <div class="text-center my-3">
                                            <span class="text-gray-500 text-md">
                                                <span v-if="getMasterActiveClientsCount(master.course)"> 
                                                    <a class="font-bold "> {{ getMasterActiveClientsCount(master.course) }} </a> 
                                                    Active Clients
                                                </span>
                                                <span v-if="getHeldCourseCount(master.course)">
                                                    <a class="font-bold"> {{ getHeldCourseCount(master.course) }} </a>
                                                    Sessions held
                                                </span>
                                            </span>
                                        </div> -->
                                    </div>
                                </figure>
                            </div>

                            <div class="grid grid-flow-row auto-rows-max w-full sm:w-3/6 sm:p-5 p-2 justify-center sm:justify-end">
                                <div class="border border-gray-300 rounded-md my-2">
                                    <div class="justify-center flex text-lg" v-if="master.online_course_status">
                                        <span class="font-bold text-gray-600">
                                            Online:
                                        </span>
                                        <div class="text-green-600 font-bold mx-1">
                                            {{ master.speciality[master.speciality.length - 1].amount_course }}{{ $page.props.currency }}
                                        </div>
                                        <span class="text-gray-600">
                                            /hour
                                        </span>
                                    </div>
                                    <div class="justify-center flex text-lg" v-if="master.in_person_course_status">
                                        <span class="font-bold text-gray-600">
                                            In-person:
                                        </span>
                                        <div class="text-green-600 font-bold mx-1">
                                            {{ master.in_person_amount_course }}{{ $page.props.currency }}
                                        </div>
                                        <span class="text-gray-600">
                                            /hour
                                        </span>
                                    </div>
                                </div>
                                <div class="text-center my-2 flex justify-center items-center">
                                    <!-- <span id="google_ads_book_trial_session_master_profile_popup"
                                        class="custom-button bg-yellow-400 text-xl shadow-md px-6 py-1 rounded-full text-white hover:shadow-xl
                                        transition duration-500 ease-in-out hover:bg-yellow-500 focus:ring focus:ring-yellow-500 cursor-pointer
                                        google_ads_book_trial_session_master_profile_popup"
                                        @click="masterReservForm.category ? openScheduleTypeModal() : error['category']=true"
                                    >Confirm free trial</span> -->
                                    <span id="google_ads_book_trial_session_master_profile_popup"
                                        class="custom-button bg-yellow-400 text-xl shadow-md px-7 py-2 rounded-full text-white hover:shadow-xl
                                        transition duration-500 ease-in-out hover:bg-yellow-500 focus:ring focus:ring-yellow-500 cursor-pointer
                                        google_ads_book_trial_session_master_profile_popup"
                                        @click="openFreeConsultation(master)"
                                    >Book a free consultation</span>
                                    <!-- <div class="tooltip-container" :style="`display: flex !important;`">
                                            <span class="material-icons text-gray-300 inline cursor-pointer text-[15px] mx-1"> help_outline </span>
                                        <span class="tooltip" :style="`text-align:left;`">
                                            This free session lets you and your coach meet, discuss your fitness needs, and plan future training. Please note that you can only book one free session. In-person trial sessions at the client's location may incur a cost. For more details, please read our Terms of Service.
                                        </span>
                                    </div> -->
                                </div>
                                <div class="text-center block text-gray-600 flex justify-center mb-4 mt-1">
                                    <div class="w-[240px]">
                                        Have a free 15-minute call with this trainer to see if it’s the right fit.

                                        <span class="tooltip-container">
                                            <span class="material-icons text-gray-300 inline cursor-pointer mx-1 absolute top-[-17px]" style="font-size: 23px"> help_outline </span>
                                            <span class="tooltip" :style="`text-align:left;`">
                                                Discuss your fitness goals, ask questions, and learn how the trainer can help you achieve your goals. This call is completely free, with no obligation to book a paid session afterward.
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="isMobile()" class="w-full block sm:hidden sm:p-5 p-2">
                                <div class="relative cursor-pointer" @click="showMasterVideo">
                                    <div class="cursor-pointer text-yellow-400 hover:text-yellow-600">
                                        <span class="material-icons youtube-play z-20">play_circle_filled</span>
                                    </div>
                                    <img class="rounded-2xl h-[280px] w-full object-cover" :src="master.video_preview_url" alt="Video preview" />
                                    <div class="video-preview-backdrop rounded-2xl"></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="! isMobile()" class="rounded-2xl shadow-lg bg-white col-span-4 hidden sm:block my-1">
                        <div class="relative cursor-pointer" @click="showMasterVideo">
                            <div class="cursor-pointer text-yellow-400 hover:text-yellow-600">
                                <span class="material-icons youtube-play z-20">play_circle_filled</span>
                            </div>
                            <img class="rounded-2xl h-[280px] w-full object-cover" :src="master.video_preview_url" alt="Video preview" />
                            <div class="video-preview-backdrop rounded-2xl"></div>
                        </div>
                    </div>
                </section>

                <div class="rounded-xl shadow-xl bg-white sm:mx-auto mx-2 p-6 my-2 relative">
                    <div class="flex flex-wrap text-center border-b-2 absolute left-0 top-[0px]">
                        <div v-for="(item,key) in infoKey"
                            :key="key"
                            @click="info_id=item.value"
                            :class="info_id===item.value ? 'bg-green-600' :'bg-gray-300'"
                            class="sm:mx-1 mx-[5px] mb-5 px-3 py-2 cursor-pointer w-auto text-center text-white rounded-b-lg">
                            <h4 class="text-base items-center">
                                {{ item.name }}
                            </h4>
                        </div>
                    </div>
                    <div class="mt-8">
                        <div v-for="(info, key) in master.info"
                            :key="key"
                            v-show="info.status>=0 && info.key===info_id"
                            class="my-1 p-2 capitalize sm:flex block">
                            
                            <div class="flex justify-start">
                                <span class="material-icons text-green-500 text-[23px] mr-2">check_circle_outline</span>
                                <p class="mt-1">
                                    {{ info.value }}
                                    <span>
                                        - {{ info.description }}
                                    </span>
                                </p>

                                <!-- view just show for certificate or show all time instead when experience -->
                                <div class="flex justify-center mt-1" v-if="info.key != 1">
                                    <span class="ml-2 cursor-pointer text-green-600" @click="openCertificateModal(info)"> View </span>
                                    <span><i class="material-icons text-green-500 launch-view-font mx-1">launch</i></span>
                                </div>
                            </div>

                            <!-- just show on experience section -->
                            <div class="flex justify-center mt-1 mx-2" v-if="info.key == 1">
                                <div class="font-bold text-gray-600"> {{ info.date }} </div>
                                <div class="mx-1"> / </div>
                                <div class="font-bold text-gray-600">
                                    <span v-if="info.end_at"> {{ info.end_at }} </span>
                                    <span v-else > Present </span> 
                                </div>
                            </div>
                        </div>

                        <!-- show bio tab -->
                        <div v-show=" 3 === info_id"
                            class="my-1 p-2 capitalize sm:flex block">
                            
                            <div class="flex justify-start">
                                <p class="mt-1 text-gray-600" v-html="master.bio"></p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="rounded-xl shadow-xl bg-white sm:mx-auto mx-2 p-6 my-2 relative">
                    <div v-if="showSchedule()">
                        <FrontSchedule :date="JSON.parse(master.schedule)"
                                    :start_date="master.start_time"
                                    :end_date="master.end_time"
                                    :holiday="master.holiday"
                                    :busy_time="master.course"
                                    :day_valid="master.day_valid"
                                    :minute_shift="master.course_time"
                                    :time_zone="master.time_zone || 'America/Toronto'"
                                    :timezoneLists="timezoneLists"
                                    @input="setSelectedDate"
                                    :canSelectable="false"
                        />
                    </div>
                    <div v-else>
                        <div class="text-center text-red-500">
                            Activity schedule not specified
                        </div>
                    </div>
                    <div class="flex items-center justify-start mt-3 gap-1">
                        <span class="material-icons text-green-600" style="font-size: 35px">error</span>
                        <span class="text-gray-600 text-base">
                            The trainer's availability for sessions. Consultations are scheduled separately.
                        </span>
                    </div>
                    <!-- <div class="">
                        <div class="flex justify-center items-center">
                            <span class="text-lg"> Training type: </span>
                            <select 
                                @change="changeCourseType"
                                v-model="courseType"
                                class="rounded-full bg-white focus:bg-indigo-100 w-[220px] m-2 p-2 border border-gray-300 shadow-md px-9">
                                <option value="null"> select training type </option>
                                <option v-if="master.in_person_course_status" value="in_person"> In-person </option>
                                <option v-if="master.online_course_status" value="online"> Online </option>
                            </select>
                        </div>
                        <div class="text-center mb-2">
                            <p v-if="courseTypeError" class="text-sm text-red-600">
                                {{ courseTypeError }}
                            </p>
                        </div>
                    </div> -->
                    <!-- <div class="flex justify-center">
                        <button v-if="showSchedule()" 
                            id="google_ads_book_your_session_master_profile"
                            class="gold-btn text-lg google_ads_book_your_session_master_profile"
                            @click="bookingFromMain">
                            Confirm free trial
                        </button>
                    </div> -->
                </div>

                <div class="rounded-xl shadow-xl bg-white sm:mx-auto mx-2 p-4 my-2">
                    <div v-if="$page.props.user && !master.comments.some(item=>item.user?.id===$page.props.user.id) && master.course.some(item=>item.user_id===$page.props.user.id && item.status===3)"
                         class=" gap-6 grid md:grid-cols-6 grid-cols-3 p-5 bg-gray-100 text-indigo-600 rounded-xl shadow-lg">
                        <div class="col-span-3 md:col-span-4">
                            <label for="body" class="block text-lg font-medium text-gray-500 py-3">
                                your comment:
                            </label>
                            <textarea :placeholder="`your comment for ${master.user?.fullName}` "
                                      v-model="commentForm.body"
                                      class="border-gray-300 placeholder-gray-300 border-dashed border rounded-lg w-full h-64 focus:ring focus:ring-indigo-200"></textarea>
                            <jet-input-error v-if="$page.props.errors?.commentForm" :message="$page.props.errors?.commentForm['body']"
                                             class="mt-2"/>
                        </div>
                        <div v-if="isClientSide()" class="col-span-3 md:col-span-2 sm:mt-12">
                            <div v-for="i in scoreTitle"
                                 class="sm:p-2 p-1 sm:mt-2">
                                <label>
                                    {{ i }}:
                                    <star-rating :star-size="20"
                                                 :date-id="i"
                                                 @click="commentForm.score[i.replaceAll(' ','_')]=rating"
                                                 @update:rating="setRating"
                                                 :increment="0.5"
                                                 :rtl="false"
                                                 :glow="10"
                                                 glow-color="#ffd055"
                                                 :show-rating="false"
                                    ></star-rating>
                                </label>
                            </div>
                        </div>
                        <div>
                            <button type="button"
                                    class="custom-button bg-yellow-400 w-full text-lg shadow-md px-3 py-1 rounded-full text-white hover:shadow-xl transition duration-500 ease-in-out hover:bg-yellow-500 focus:ring focus:ring-yellow-500"
                                    @click="sendComment"
                            >
                                Submit Comment
                            </button>
                        </div>
                    </div>
                    <div class="p-6 flex items-center justify-center">
                        <span class="text-3xl py-4">Client reviews </span>
                        <span class="text-sm mx-2" v-if="master.comments.length>0"> ({{ master.comments.length }}) </span>
                        <span class="text-sm mx-2" v-else> (0) </span>
                    </div>
                    <div v-show="master.comments.length>0" class="grid grid-flow-row auto-rows-max sm:mx-80 mx-1">
                        <div class="grid items-center">
                            <div class="w-full">
                                <label class="text-base text-gray-600">Overall satisfaction</label>
                            </div>
                            <div class="pt-2 w-full flex justify-center">
                                <div :style="`width: ${getScore('overall_satisfaction')}%`" class="h-2 rounded-lg text-white bg-green-500"></div>
                                <span class="text-xs font-semibold inline-block text-gray-700 mx-5">
                                    {{ getScore('overall_satisfaction') }}%
                                </span>
                            </div>
                        </div>
                    </div>
                    <hr class="my-4 text-gray-900 w-full">
                    <div v-for="(comment,key) in master.comments" :key="key" v-show="key<commentLength" class="border sm:p-4 p-2 sm:m-4 border-gray-300 rounded-2xl mt-2">
                        <span v-if="$page.props.user && comment.user?.id===$page.props.user.id"
                              class="material-icons cursor-pointer text-indigo-500"
                              @click="editComment(comment.id)">edit_note</span>
                        <div class="grid grid-cols-3 md:grid-cols-9 md:grid p-2">
                            <div class="md:col-span-1 col-span-3 grid items-center">
                                <img class="w-20 h-20 rounded-full mx-auto" :src="comment.user?.profile_photo_url" loading="lazy" :alt="comment.user?.fullName">
                                <span class="text-base text-gray-600 mx-auto my-3">{{ comment.user?.fullName }}</span>
                                <div class="justify-center sm:hidden flex">
                                    <span class="material-icons text-indigo-500">schedule</span>
                                    <p class="mt-1">{{ new Date(comment.created_at).toDateString() }}</p>
                                </div>
                            </div>
                            <div class="md:col-span-5 col-span-3 sm:p-6 p-3">
                                {{ comment.body }}

                                <div v-if="isClientSide()" class="mt-1 sm:mt-3">
                                    <div v-for="(i,k) in JSON.parse(comment.score)" :key="k">
                                        <div class="flex w-full justify-between items-center" v-if="k.replaceAll('_', ' ') == 'overall satisfaction'">
                                            <span> Overall satisfaction - {{ getNormalScore(i) }}% :</span>
                                            <div class="relative pt-1 flex-grow ml-4">
                                                <div class="overflow-hidden h-2 my-4 text-xs flex rounded border border-indigo-100">
                                                    <div :style="`width: ${getNormalScore(i)}%`" class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-green-500"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="md:col-span-3 col-span-3 sm:block hidden">
                                <div class="text-center flex items-center sm:justify-end justify-center">
                                    <span class="material-icons text-indigo-500">schedule</span>
                                    <p>{{ new Date(comment.created_at).toDateString() }}</p>
                                </div>
                            </div>
                            <div v-if="commentSelect===comment.id"
                                 class="gap-6 grid md:grid-cols-6 grid-cols-3 col-span-9 p-5 bg-gray-100 text-indigo-600 rounded-xl shadow-lg">
                                <div class="col-span-3 md:col-span-4">
                                    <label for="body" class="block text-lg font-medium text-gray-500 py-3">
                                        your comment:
                                    </label>
                                    <textarea :placeholder="`your comment for ${master.user?.fullName}` "
                                              v-model="commentForm.body"
                                              class="border-gray-300 placeholder-gray-300 border-dashed border rounded-lg w-full h-64 focus:ring focus:ring-indigo-200"></textarea>
                                    <jet-input-error v-if="$page.props.errorBags?.commentForm" :message="$page.props.errorBags?.commentForm['body']"
                                                     class="mt-2"/>
                                </div>
                                <div v-if="isClientSide()" class="col-span-3 md:col-span-2 sm:mt-12">
                                    <div v-for="(i, key) in ['overall satisfaction']"
                                        :key="key"
                                         class="sm:p-2 p-1 sm:mt-2">
                                        <label>
                                            {{ i }}:
                                            <star-rating :star-size="20"
                                                         :date-id="i"
                                                         :rating="commentForm.score[i.replaceAll(' ','_')]"
                                                         @click="commentForm.score[i.replaceAll(' ','_')]=rating"
                                                         @update:rating="setRating"
                                                         :increment="0.5"
                                                         :rtl="false"
                                                         :glow="10"
                                                         glow-color="#ffd055"
                                                         :show-rating="false"
                                            ></star-rating>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-span-3 md:col-span-2 sm:w-2/3">
                                    <button type="button"
                                            class="custom-button bg-yellow-400 w-full text-lg shadow-md px-3 py-1 rounded-full text-white hover:shadow-xl transition duration-500 ease-in-out hover:bg-yellow-500 focus:ring focus:ring-yellow-500"
                                            @click="submitEditComment"
                                    >
                                        Edit Comment
                                    </button>
                                </div>
                            </div>
                        </div>
                        <!--                    <div class="w-full">-->
                        <!--                        <span class="flex border border-gray-500 rounded-full p-2">-->
                        <!--                            <span class="material-icons">layers</span>-->
                        <!--                            <span></span>-->
                        <!--                        </span>-->
                        <!--                    </div>-->
                    </div>
                    <div v-show="master.comments.length>commentLength" class="text-center text-indigo-500">
                        <span class="material-icons cursor-pointer hover:translate-y-4 animate-bounce"
                              @click="commentLength=commentLength+10">expand_more</span>
                    </div>
                </div>
            </div>

            <jet-confirmation-modal v-if="CourseDialog" @close="CourseDialog=false">
                <template #title>Course Reservation</template>
                <template #content>
                    <div v-show="$page.props.error" class="text-center mb-4 font-medium text-sm bg-red-100 p-4 text-red-600 rounded-md">
                        <span>{{$page.props.error}}</span>
                    </div>
                    <div class="sm:p-3 p-0 date-picker" dir="ltr">
                        <div v-if="showSchedule()">
                            <FrontSchedule :date="JSON.parse(master.schedule)"
                                        :start_date="master.start_time"
                                        :end_date="master.end_time"
                                        :holiday="master.holiday"
                                        :busy_time="master.course"
                                        :day_valid="master.day_valid"
                                        :minute_shift="master.course_time"
                                        :time_zone="master.time_zone || 'America/Toronto'"
                                        :timezoneLists="timezoneLists"
                                        @input="setSelectedDate"
                            />
                        </div>
                        <div v-else>
                            <div class="text-center text-red-500">
                                Activity schedule not specified
                            </div>
                        </div>
                    </div>
                </template>
                <template #footer>
                    <button v-if="showSchedule()" class="gold-btn" @click="booking">
                        Book your session
                    </button>
                    <jet-secondary-button class="ml-2" @click="CourseDialog = false">
                        cancel
                    </jet-secondary-button>
                </template>
            </jet-confirmation-modal>

            <jet-confirmation-modal v-if="checkMobile" @close="checkMobile=false" maxWidth="xl">
                <template #content>
                    <div class="text-left mx-2">
                        <div class="p-4">
                            <h3 v-if="isUser" class="text-4xl text-gray-600 font-bold">Login</h3>
                            <h3 v-if="showCodeBox" class="text-4xl text-gray-600 font-bold">SignUp</h3>
                            
                            <div class="my-2">
                            <span v-if="$page.props.modalError">
                                <a class="sm:text-lg text-[14px] bg-red-100 text-red-600 py-1 px-3 rounded-lg"> {{ $page.props.modalError }}! </a>
                                <p v-if="!showCodeBox" class="text-indigo-500" href="/forgot-password">Forgot your password?</p>
                            </span>
                            </div>
                            <jet-label v-if="!isUser && !showCodeBox" for="Mobile" class="mb-3" value="Please enter your email address:" />
                            <jet-label for="Email" value="Email" />
                            <input type="text"
                                v-model="mobile"
                                placeholder="test@gmail.com" 
                                :disabled="isUser || showCodeBox ? true : false"
                                class="shadow-sm my-3 focus:ring-indigo-500 focus:border-indigo-500 mt-1 block w-full sm:text-sm border-gray-300 rounded-md border">
                            <jet-input-error 
                                v-if="$page.props.errorBags?.mobileConfirmForm" 
                                :message="$page.props.errorBags?.mobileConfirmForm['mobile']"             
                                class="mt-2"/>
                            <!-- <div v-if="showCodeBox">
                                <jet-label for="Mobile" value="Verification Code" />
                                <input
                                    type="number"
                                    placeholder="6-digit verification code"
                                    class="shadow-sm my-3 focus:ring-indigo-500 focus:border-indigo-500 mt-1 block w-full sm:text-sm border-gray-300 rounded-md border"
                                    v-model="code">
                                <jet-input-error 
                                    v-if="$page.props.errorBags?.mobileConfirmForm" 
                                    :message="$page.props.errorBags?.mobileConfirmForm['active_code']"
                                    class="mt-2"/>
                            </div> -->
                            <div v-if="isUser || showCodeBox">
                                <jet-label 
                                    for="Mobile" 
                                    value="Password"
                                />
                                <input 
                                    type="password"
                                    class="shadow-sm my-3 focus:ring-indigo-500 focus:border-indigo-500 mt-1 block w-full sm:text-sm border-gray-300 rounded-md border"
                                    v-model="password"
                                    placeholder="password"
                                >
                                <jet-input-error 
                                    v-if="$page.props.errorBags?.mobileConfirmForm" 
                                    :message="$page.props.errorBags?.mobileConfirmForm['password']"
                                    class="mt-2"/>
                            </div>

                            <div class="text-center mt-3">
                                <span class="text-red-500 text-sm" v-html="msg"></span>
                            </div>

                            <jet-label for="terms" class="mt-4" v-if="showCodeBox">
                                <div class="flex items-center">
                                    <jet-checkbox name="terms" id="terms" v-model="terms"/>
                                    <div class="ml-2">
                                        By using this website or signing up, you agree to Happy Trainers <a target="_blank" href="/term-of-service"
                                        class="underline text-sm text-gray-600 hover:text-gray-900">Terms of Service</a> and 
                                        <a target="_blank" href="/privacy-policy" class="underline text-sm text-gray-600 hover:text-gray-900">
                                        Privacy Policy</a>
                                    </div>
                                </div>
                            </jet-label>
                        </div>
                        <div class="text-center px-5">
                            <button 
                                v-if="!isUser && !showCodeBox" 
                                class="my-1 w-full gold-btn text-base"
                                @click="showCodeBox ? checkCode() :  checkUser()" :disabled="disabledButton">Proceed to sign up or log in
                            </button>
                            <button 
                                v-if="showCodeBox" 
                                class="my-1 w-full gold-btn text-base"
                                @click="checkCode()" :disabled="disabledButton"> Sign up
                            </button>
                            <button 
                                v-if="isUser" 
                                class="my-1 gold-btn w-full text-base"
                                    @click="login">Log in
                            </button>
                            <button 
                                v-if="isUser" 
                                class="my-1 gold-btn bg-gray-400 w-full text-base"
                                style="background-color:#ebd371 !important"
                                @click="forgotPassword">Forgot password
                            </button>
                            <button 
                                class="my-1 w-full gold-btn bg-gray-400 p-1 px-4 text-base"
                                style="background-color:#dddddd !important"
                                @click="closeCheckMobil">close
                            </button>

                            <!-- <div class="relative flex py-5 items-center">
                                <div class="flex-grow" style="border:1px solid #e7e2e2"></div>
                                <span class="flex-shrink mx-4 text-gray-400">Or</span>
                                <div class="flex-grow" style="border:1px solid #e7e2e2"></div>
                            </div>
                            
                            <google-auth /> -->

                        </div>
                    </div>
                </template>
            </jet-confirmation-modal>
            <jet-confirmation-modal v-if="showCertificateModal">
                <template #content>
                    <iframe
                        v-if="isCertificatePdf(modalInfo)" 
                        :src="modalInfo.fileUrl"
                        class="w-full"
                        height="500"
                    />
                    <img v-else class="w-full" :src="modalInfo.fileUrl" :alt="modalInfo.value" />
                    <div class="text-center text-lg text-gray-600 my-3 font-bold">
                        {{ modalInfo.value}}
                    </div>
                </template>
                <template #footer>
                    <div class="flex justify-center">
                        <button class="gold-btn" @click="closeCertificateModal">
                            Go Back
                        </button>
                    </div>
                </template>
            </jet-confirmation-modal>
            <!-- <MasterScheduleType
                :master="master"
                :show="showScheduleTypeModal"
                @select="selectScheduleType"
                @close="closeScheduleTypeModal"
            /> -->
            <FreeConsultationModal
                :master="freeConsultationMaster"
                :show="showFreeConsultationModal"
                @close="closeFreeConsultation"
            />
            <VideoShow :showPlayer="masterVideoSelect.isShowVideo" :video="masterVideoSelect.video" @close="closeMasterVideo"/>
        </template>
    </main-site>
</template>

<script>

let StarRating;

if (typeof window !== "undefined" && typeof document !== "undefined") {
    StarRating = require('vue-star-rating').default
}

import {Inertia} from '@inertiajs/inertia';
import Select from "@/Jetstream/Select";
import Button from "@/Jetstream/Button";
import Input from "@/Jetstream/Input";
import JetConfirmationModal from '@/Jetstream/ConfirmationModal';
import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import FrontSchedule from "@/Pages/Components/FrontSchedule";
import JetInputError from '@/Jetstream/InputError';
import JetCheckbox from '@/Jetstream/Checkbox';
import Label from "@/Jetstream/Label";
import myMixin from "@/myMixin";
import MainSite from "@/Pages/Components/MainSite";
import {Link, InertiaHead} from '@inertiajs/inertia-vue3';
import JetLabel from '@/Jetstream/Label';
import GoogleAuth from "@/Components/Auth/GoogleAuth";
import Loading from "@/Jetstream/Loading";
// import MasterScheduleType from "@/Pages/Components/MasterScheduleType.vue";
import VideoShow from "@/Jetstream/VideoShow";
import FreeConsultationModal from "@/Pages/Components/FreeConsultationModal.vue";

export default {
    name: "Master",
    mixins: [myMixin],
    components: {
        Label, FrontSchedule,
        Input, Button, Select,
        MainSite, Link, JetConfirmationModal,
        JetSecondaryButton, JetInputError, JetCheckbox, StarRating, InertiaHead, JetLabel, Inertia, GoogleAuth,
        Loading, VideoShow, FreeConsultationModal
    },
    props: {
        master: Object,
        info_key: Array,
        seo: Object,
        canonicalLink: String,
        timezoneLists: Array,
    },
    data() {
        return {
            courseType: null,
            courseTypeError: null,
            showFreeConsultationModal: false,
            freeConsultationMaster: null,
            showScheduleTypeModal: false,
            isLoading: false,
            modalInfo: {},
            showCertificateModal: false,
            infoKey: [
                { name: 'Verified certificates', value: 2 },
                { name: 'Experience', value: 1 },
                { name: 'Bio', value: 3 },
            ],
            info_id: 2,
            disabledButton:false,
            scoreTitle: ['overall satisfaction',
                // 'rhetorical','report to parents','regular classes'
            ],
            terms: false,
            checkMobile: false,
            msg: null,
            show1: false,
            isUser: false,
            showCodeBox: false,
            mobile: null,
            code: null,
            password: null,
            server_response: false,
            CourseDialog: false,
            isFallow: false,
            rating: null,
            commentSelect: null,
            commentLength: 10,
            error: {
                category: false
            },
            commentForm: this.$inertia.form({
                '_method': 'POST',
                master_profile_id: this.master.id,
                body: '',
                score: {
                    overall_satisfaction: null,
                    rhetorical: null,
                    report_to_parents: null,
                    regular_classes: null,
                }
            }, {
                resetOnSuccess: true,
                bg: 'commentForm'
            }),
            masterReservForm: this.$inertia.form({
                category: null,
                time: null,
                time_zone: null,
                master_profile_id: this.master.id,
                type: null,
            }, {
                resetOnSuccess: false,
                bag: 'masterReservForm'
            }),
            masterVideoSelect: this.master,
        }
    },
    watch: {
        code(val) {
            if (val.length === 6 && this.password.toString().length >= 6) {
                this.checkCode()
            }
        },
    },
    mounted() {
        this.setMasterSpeciality();
        // if (this.$page.props.user) {
        //     this.getFallowingTrainer()
        // }
    },
    methods: {
        openFreeConsultation(_master){
            this.showFreeConsultationModal = true;
            this.freeConsultationMaster = _master;
        },
        closeFreeConsultation(){
            this.showFreeConsultationModal = false;
            this.freeConsultationMaster = null;
        },
        closeMasterVideo(_master){
            this.masterVideoSelect.isShowVideo = false;
        },
        showMasterVideo(){
            this.masterVideoSelect.isShowVideo = true;
        },
        forgotPassword() {
            window.location.href = route('password.request');
        },
        
        setMasterSpeciality() {
            this.masterReservForm.category = this.master.speciality && this.master.speciality.length > 0 ?
                this.master.speciality[0].service_category_id : 
                null;
        },
        closeCertificateModal() {
            this.showCertificateModal = false;
            this.modalInfo = {};
        },
        openCertificateModal(_info) {
            if( this.isMobile() && this.isCertificatePdf(_info)){
                return window.open(_info.fileUrl);
            }
            this.showCertificateModal = true;
            this.modalInfo = _info;
        },
        isCertificatePdf(_info){
            return _info.fileUrl.includes('.pdf') ? true : false;
        },
        showSchedule() {
            return this.master.schedule &&
                this.master.start_time &&
                this.master.end_time &&
                this.master.course_time
        },
        closeCheckMobil() {
            this.checkMobile = false;
            this.code = null;
            this.mobile = null;
            this.password = null;
            this.isUser = false;
            this.showCodeBox = false;
            this.msg = null;
            this.$page.props.error = null;
        },
        checkUser() {
            if (this.mobile) {
                this.disabledButton = true;
                this.server_response = false
                this.isUser = false
                this.showCodeBox = false
                this.msg = null;
                this.isLoading = true;
                axios.get(`/get-user?email=${this.mobile}`)
                    .then(response => {
                        if (response.data.email) {
                            this.isUser = true
                            this.msg = `Please log in to your panel!`;
                            this.isLoading = false;
                        } else {
                            this.verificationMobile()
                        }
                    }).catch((error) => {
                        //
                    })
                    .finally( () => this.disabledButton = false );
            } else {
                this.msg = 'Please enter your email address!';
            }
        },
        verificationMobile() {
            if (!this.server_response) {
                this.isLoading = true;
                axios.post('/validation-email', {email: this.mobile}).then(response => {
                    this.showCodeBox = true
                    // this.msg = `Confirmation code sent to email ${this.mobile} `
                }).catch((error) => {
                    let errors = error.response.data.errors;
                    // this.msg = errors['mobile'];
                })
                .finally( () => {
                    this.isLoading = false;
                })
                this.server_response = true
            }
        },
        checkCode() {
            if (this.mobile && this.password && this.terms ) {
                let data = {active_code: this.code, email: this.mobile, ajax: true, password: this.password};
                this.$inertia.post('/user-activate-master', data , {
                    onSuccess: () => {
                        this.$page.props.user ? this.checkMobile = false : ''
                        this.booking()
                    }
                })
            } else if( this.mobile && !this.password && this.terms ) { 
                this.msg = 'Please enter your password!';
            } else if( this.mobile && this.password && !this.terms) {
                this.msg = 'Please check the Terms of Service and Privacy Policy!';
            } else {
                this.msg = 'Please enter your password and check the Terms of Service and Privacy Policy!';
            }
        },
        login() {
            if ( this.mobile && this.password) {
                this.msg = null;
                this.$inertia.post('/userLogin', {email: this.mobile, password: this.password}, {
                    onSuccess: () => {
                        this.$page.props.user ? this.checkMobile = false : ''
                        this.booking()
                    }
                }) 
            } else if ( this.mobile && !this.password ) {
                this.msg = 'Please enter your password!';
            } else {
                this.msg = 'Please enter your information carefully.';
            }
        },
        sendComment() {
            this.commentForm.post('/dashboard/user/comment-submit', {
                onSuccess: () => this.commentForm.reset()
            })
        },
        editComment(id) {
            this.commentSelect = id
            let comment = this.master.comments.find(item => item.id === id)
            const scores = JSON.parse(comment.score)
            this.commentForm = this.$inertia.form({
                '_method': 'PUT',
                master_profile_id: this.master.id,
                body: comment.body,
                score: {
                    overall_satisfaction: parseFloat(scores.overall_satisfaction),
                    rhetorical: parseFloat(scores.rhetorical),
                    report_to_parents: parseFloat(scores.report_to_parents),
                    regular_classes: parseFloat(scores.regular_classes),
                },
                id: id
            }, {
                resetOnSuccess: true,
                bg: 'commentForm'
            })
        },
        submitEditComment() {
            this.commentForm.post('/dashboard/user/edit-comment', {
                onSuccess: () => {
                    this.commentForm.reset()
                    this.commentSelect = null
                }
            })
        },
        setRating(rating) {
            this.rating = rating
        },
        MasterFallow() {
            if (process.browser && typeof window !== "undefined" && !this.$page.props.user) {
                window.location.href = '/login'
                return
            }
            axios.post('/master-favorite', {id: this.master.id}).then(response => {
                if (response.data === 1) {
                    this.isFallow = true
                    return
                }
                this.isFallow = false
            }).catch((error) => {
                //
            })
        },
        getFallowingTrainer() {
            axios.get( `/master-favorite/${this.master.id}` ).then(response => {
                if (response.data === 1) {
                    this.isFallow = true
                }
            })
        },
        setSelectedDate(e, _timezone) {
            if (e && typeof e.format === "function") {
                this.masterReservForm.time = e.format("YYYY-MM-DD HH:mm");
                this.masterReservForm.time_zone = _timezone;
            }
        },
        getActiveCourse(course) {
            let count = 0
            for (let item of course) {
                if (item.status === 1 && item.chosen_date < new Date().toDateString()) {
                    count++
                }
            }
            return count
        },
        openScheduleTypeModal(){
            this.showScheduleTypeModal = true;
        },
        closeScheduleTypeModal(){
            this.showScheduleTypeModal = false;
        },
        selectScheduleType(_data){
            this.showScheduleTypeModal = false;
            this.masterReservForm.type = _data;
            this.getCourse();
        },
        changeCourseType(_event){
            this.masterReservForm.type = _event.target.value;
        },
        getCourse() {
            this.error.category = false
            this.CourseDialog = true
        },
        bookingFromMain(){
            if( ! this.courseType ) {
                return this.courseTypeError = 'Please first select training type'
            }
            this.courseTypeError = null;
            this.masterReservForm.type = this.courseType;
            return this.booking();
        },
        booking() {
            if (this.masterReservForm.time && !this.$page.props.user && !this.isUser) {
                this.CourseDialog = false
                this.checkMobile = true
                // window.location.href='/login'
            } else {
                this.masterReservForm.post('/get-course', {
                    onSuccess: () => this.CourseDialog = true
                })
            }
        },
        getScore(val) {
            let rate = 0
            let length = 0
            for (let comment of this.master.comments) {
                const scores = JSON.parse(comment.score)
                if (scores[val]) {
                    length++
                    rate = rate + scores[val]
                }
            }
            const avg = rate / length
            return Math.floor((isNaN(avg) ? 0 : avg / 5) * 100)
        },
        getNormalScore(_val) {
            return Math.floor((_val * 100) / 5);
        }
    }
}
</script>

<style>
.vue-star-rating {
    contain: content;
}

.master-lists-avatar {
    width: 160px;
    min-width: 160px;
    max-width: 160px;
    height: 160px;
    min-height: 160px;
    max-height: 160px;
}

.card-blur {
    margin: auto;
    min-height: 166px;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: fit-content;
    border-radius: 10px;
    z-index: 99999;
    box-shadow: 0px 16px 46px -15px #4338ca;
    background-color: rgb(234 234 234 / 64%);
    -webkit-backdrop-filter: blur(20px) saturate(180%);
    backdrop-filter: blur(20px) saturate(180%);
}

@media only screen and (max-width: 600px) {
    .date-picker {
        font-size: 10px;
    }
}
</style>
